module.exports = __webpack_public_path__ + "img/top_bg.3c51cfce.png";